export enum dreVisions {
  boxVision = 1,
  gerencialVision,
  competencyVision
}